export default __webpack_public_path__ + "static/media/DMSans-Regular.ada26c6b.ttf";